import { fetchJson } from "../../../../utils";
import { constants } from "../../common";
import { BasketResponse, BasketItemRequest, ApiResponseWithData } from "./models";

export function updateItemBasket(request: BasketItemRequest) {
  return fetchJson<ApiResponseWithData<BasketResponse>>(constants.urls.basketV2.update, {
    method: "PATCH",
    body: JSON.stringify(request),
  });
}
